/*
 * Copyright (c) Nexign, JSC, 1992-2024.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.29.0
 * @since 1.29.0
 */

import { IWizardAdditionalReportsTranslation } from '@modules/internationalization/types/wizards/additionalReports';
import {
    EWizardAdditionalReports,
    EWizardAdditionalReportsSteps,
} from '@pages/WizardAdditionalReports/wizardAdditionalReportsConsant';

import { initWizardPropsTranslation } from './initWizardTranslation';

export const initWizardAdditionalReportsTranslation: IWizardAdditionalReportsTranslation = {
    ...initWizardPropsTranslation,
    [EWizardAdditionalReportsSteps.ChooseStep]: {
        chooseReport: '',
    },
    [EWizardAdditionalReportsSteps.PrepareStep]: {
        changeSubscribersList: '',
        maxAutoReportsWarning: '',
        orderLater: '',
        orderNow: '',
        orderReportTitle: '',
        periodLabel: '',
        reportFormat: '',
        tooManyAutoReports: '',
        tooManyAutoReportsLink: '',
        subscribersEditModal: {
            apply: '',
            choose: '',
            chooseAll: '',
            chooseNone: '',
            chosenCount: '',
            close: '',
            search: '',
            title: '',
        },
    },
    [EWizardAdditionalReportsSteps.ConfirmStep]: {
        compressionPassword: '',
        destEmailForLink: '',
        needCompression: '',
        reportCreationTime: '',
        reportCreationType: '',
        reportCreationTypeOnNumberOfDay: '',
        reportCreationTypeWeek: {},
        reportDescription: '',
        reportFilteredBy: '',
        reportFilteredByAccounts: '',
        reportFilteredBySubscribers: '',
        reportFormat: '',
        reportType: '',
        sendDocumentTitle: '',
    },
    reports: {
        [EWizardAdditionalReports.REPORT_SUBSCRIBERS_WITH_LIMITS]: '',
        [EWizardAdditionalReports.REPORT_SUBSCRIBERS_WITH_MIN_LIMITS]: '',
        [EWizardAdditionalReports.REPORT_SUBSCRIBERS_WITH_PARAMETERS]: '',
        [EWizardAdditionalReports.REPORT_SUBSCRIBERS_WITH_BLOCK]: '',
        [EWizardAdditionalReports.REPORT_SUBSCRIBERS_NEW]: '',
        [EWizardAdditionalReports.REPORT_SUBSCRIBERS_WITH_STATIC_IP]: '',
    },
    wizardReport: {
        email: '',
        header: '',
        phone: '',
        toSubscribers: '',
        toUser: '',
    },
    wizardSummary: {
        details: '',
        orderMessageEnd: '',
        orderMessageStart: '',
        title: '',
    },
};
